<button mat-icon-button
        cdkOverlayOrigin
        #bellTrigger="cdkOverlayOrigin"
        [matTooltip]="'notifications.bell.tooltip' | translate"
        [attr.aria-label]="'notifications.bell.tooltip' | translate"
        (click)="toggle()">
  <mat-icon class="bell-icon"
            [class.bell-ring]="ringing()"
            [matBadge]="badgeText()"
            [matBadgeHidden]="svc.unseenCount() === 0"
            matBadgeColor="warn"
            matBadgeSize="small"
            aria-hidden="false">notifications</mat-icon>
</button>

<ng-template cdkConnectedOverlay
             [cdkConnectedOverlayOrigin]="bellTrigger"
             [cdkConnectedOverlayOpen]="panelOpen()"
             [cdkConnectedOverlayHasBackdrop]="true"
             cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
             [cdkConnectedOverlayPositions]="overlayPositions"
             [cdkConnectedOverlayViewportMargin]="8"
             [cdkConnectedOverlayPush]="true"
             (backdropClick)="close()"
             (detach)="close()">
  <app-notification-panel (closed)="close()"></app-notification-panel>
</ng-template>
